export default __webpack_public_path__ + "static/media/KheshattaOasisMap.d8d5f816.jpg";